function getGeoLocation(success, fail) {
  navigator.geolocation.getCurrentPosition(success, fail, {timeout: 5000});
}

// geolocationDeniedError passed from cms
function getFAOGeoLocationError(error, geolocationDeniedError) {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      return geolocationDeniedError;
    case error.POSITION_UNAVAILABLE:
      return "Location information is unavailable!";
    case error.TIMEOUT:
      return "The request to get your location timed out!";
    case error.UNKNOWN_ERROR:
      return "An unknown error occurred!";
  }
}

export default {
  getGeoLocation,
  getFAOGeoLocationError
}
